import React, { useState } from 'react';
import StyledDrawer from '../../../Components/Drawer';

const HelpDrawer = () => {
    const [isDrawerOpen] = useState(true);

    return <StyledDrawer isDrawerOpen={isDrawerOpen} />;
};

export default HelpDrawer;
